import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { ObjectSchema, object, string } from "yup";

export type LoginFormValues = {
  email: string;
  password: string;
};

const loginValidationSchema: ObjectSchema<LoginFormValues> =
  object({
    email: string().email().required("Email field is required"),
    password: string().required("Password field is required"),
  })
    .required();

export function useLoginForm() {
  return useForm<LoginFormValues>({
    resolver: yupResolver(loginValidationSchema),
    reValidateMode: "onChange",
    mode: "onChange",
  });
}
